/* eslint-disable react/display-name */
import React, { memo, useCallback } from 'react';
import Modal from 'react-responsive-modal';
import styled from 'styled-components';

import { AlertsListItemTitle } from '../alerts/alertsListItemTitle';
import { RunningManIcon } from '../common/icons/runningManIcon';
import { translate } from '../../common/translation/translate';
import { OutdoorSportsIndexLegendLevel } from '../common/interfaces/types';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';

interface OutdoorSportsIndexExplanatoryPopup {
    outdoorSportsIndexLegendLevels: OutdoorSportsIndexLegendLevel[];
    open: boolean;
    onClose: () => void;
}

export const OutdoorSportsIndexExplanatoryPopup = memo(({
    outdoorSportsIndexLegendLevels,
    open = false,
    onClose
}: OutdoorSportsIndexExplanatoryPopup) => {
    const onCloseEvent = useCallback(() => {
        onClose();
    }, []);

    return (
        <Modal open={open} onClose={onCloseEvent} styles={modalStyles} center={true}>
            <ModalHeader>
                <AlertsListItemTitle>
                    {`${translate('outdoorSportsIndex')}`}
                </AlertsListItemTitle>
            </ModalHeader>
            <RowsContainer>
                {outdoorSportsIndexLegendLevels?.map((outdoorSportsIndexLegendLevel, i) => {
                    return <div key={i}>
                        <Row>
                            <IconWrapper>
                                <RunningManIcon 
                                    backgroundFillColor={outdoorSportsIndexLegendLevel?.indexLevelColor} 
                                    width={34}
                                    height={34}  
                                />
                            </IconWrapper>
                            <MessageContainer>
                                <TitleText>{outdoorSportsIndexLegendLevel?.indexLevelDisplayStr}</TitleText>
                                <MessageBody>{outdoorSportsIndexLegendLevel?.indexLevelDescription}</MessageBody>
                            </MessageContainer>
                        </Row>
                    </div>;
                })}
            </RowsContainer>
        </Modal>
    );
});

const modalStyles = {
    closeIcon: {
        fill: '#555555',
        width: 24,
        height: 24
    }
};

const ModalHeader = styled.h1`
    display: flex;
    flex-direction: row;
    color: #555555;
    background-color: #FFFFFF;
    font-family: Source Sans Pro;
    font-size: 18px;
    font-weight: 600;
    padding: 10px 0 10px 20px;
`;

const RowsContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: #F9F9F9;
    color: #555555;
    font-family: Source Sans Pro;
    font-size: 16px;
    white-space: pre-wrap;
    padding-bottom: 20px;
    width: 450px;

    @media ${smallMediaQuery} {
        width: 100%;
    }
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 10px 0 15px 0;
`;

const IconWrapper = styled.div`
    width: 40px;
    margin: 0 15px 0 30px;
`;

const MessageContainer = styled.div`
    margin-top: 25px;
`;

const TitleText = styled.div`
    font-weight: 600;
`;

const MessageBody = styled.div`
    margin-top: 5px;
    font-weight: 400;
    width: 90%;
`;